export default "__VITE_ASSET__ec2d16c0__"